import _defineProperty from '@babel/runtime/helpers/defineProperty';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  min: 0,
  max: 99,
  state: 'enabled',
  decreaseButtonProps: {
    'aria-label': 'decrease'
  },
  increaseButtonProps: {
    'aria-label': 'increase'
  }
};
var decreaseButtonPropsMapper = function decreaseButtonPropsMapper(value, min, onChange, state, props) {
  var disabled = state === 'disabled';
  var decreaseDisabled = disabled || value <= min;
  return _objectSpread(_objectSpread({}, props), {}, {
    onClick: function onClick() {
      return onChange(value - 1);
    },
    hierarchy: 'secondary',
    variant: 'icon',
    disabled: decreaseDisabled,
    state: decreaseDisabled ? 'disabled' : 'enabled',
    leadingIcon: 'fill.symbol.minus',
    size: 's'
  });
};
var increaseButtonPropsMapper = function increaseButtonPropsMapper(value, max, onChange, state, props) {
  var disabled = state === 'disabled';
  var increaseDisabled = disabled || value >= max;
  return _objectSpread(_objectSpread({}, props), {}, {
    onClick: function onClick() {
      return onChange(value + 1);
    },
    hierarchy: 'secondary',
    variant: 'icon',
    disabled: increaseDisabled,
    state: increaseDisabled ? 'disabled' : 'enabled',
    leadingIcon: 'fill.symbol.plus',
    size: 's'
  });
};
var typographyPropsMapper = function typographyPropsMapper(state, props) {
  return _objectSpread({
    variant: 'heading-l',
    textColor: state === 'disabled' ? 'base.disabled' : 'deprecated.secondary.interactive'
  }, props);
};

export { decreaseButtonPropsMapper, defaultProps, increaseButtonPropsMapper, typographyPropsMapper };
//# sourceMappingURL=Counter.mappers.js.map
